const mutations = {
    set_isLogin(state, data) {
        state.isLogin = data
        window.sessionStorage.setItem('isLogin', data)
    },
    set_username(state, data) {
        state.username = data
        window.sessionStorage.setItem('username', data)
    },
    set_token(state, data) {
        state.token = data
        window.sessionStorage.setItem('token', data)
    },
    set_authMenu(state, data) {
        state.authMenu = data
        window.sessionStorage.setItem('authMenu', JSON.stringify(data))
    },
    set_baseMenu(state, data) {
        state.baseMenu = data
        window.sessionStorage.setItem('baseMenu', data)
    },
    set_authButton(state, data) {
        state.authButton = data
        window.sessionStorage.setItem('authButton', JSON.stringify(data))
    },
    set_showMenuList(state, data) {
        state.showMenuList = data
        window.sessionStorage.setItem('showMenuList', JSON.stringify(data))
    },
    set_hasMenu(state, data) {
        state.hasMenu = data
    }

}
export default mutations